import React from 'react';
import { ErrorMessage, FieldProps, FormikValues } from 'formik';
import { Field } from '~/components/Formik';
import {
    detailCollectionValidation,
    detailValueValidation,
    isAbnormalValue,
    outOfRangeText,
} from '~/util';

interface ActionRatioProps {
    detail: MeasureDetailType;
    getName: (x: MeasureDetailType) => null | string;
    checkboxId: string;
    readOnly: boolean;
    formik: FormikValues;
}
export function ActionRatio({ detail, getName, checkboxId, readOnly, formik }: ActionRatioProps) {
    function validate(value: string, name: string, ratio: string) {
        if (!formik.values[checkboxId]) return '';
        if (!value) {
            return detailCollectionValidation([detail], formik, getName);
        }
        return detailValueValidation(value, detail, ratio, name);
    }

    return (
        <>
            <div className="gap-action-row-results">
                <Field
                    name={getName(detail)}
                    validate={(value: string) => validate(value, 'Systolic', 'ratio')}
                >
                    {({ field, meta }: FieldProps) => (
                        <span>
                            <input
                                type="text"
                                {...field}
                                className={`form-control gap-detail-answer-input ${
                                    meta.touched && isAbnormalValue(field.value, detail, 'ratio')
                                        ? 'border-warning'
                                        : ''
                                }`}
                                aria-label="Systolic Results"
                                disabled={readOnly || !formik.values[checkboxId]}
                            />
                        </span>
                    )}
                </Field>
                <span className="mx-1">/</span>
                <Field
                    name={`${getName(detail)}2`}
                    validate={(value: string) => validate(value, 'Diastolic', 'ratio2')}
                >
                    {({ field, meta }: FieldProps) => (
                        <span className="gap-action-row-results">
                            <input
                                type="text"
                                {...field}
                                className={`form-control gap-detail-answer-input ${
                                    meta.touched && isAbnormalValue(field.value, detail, 'ratio2')
                                        ? 'border-warning'
                                        : ''
                                }`}
                                aria-label="Diastolic Results"
                                disabled={readOnly || !formik.values[checkboxId]}
                            />
                        </span>
                    )}
                </Field>
            </div>
            <div className="text-danger">
                <div>
                    <ErrorMessage name={getName(detail)!} />
                </div>
                <div>
                    <ErrorMessage name={`${getName(detail)}2`} />
                </div>
            </div>
            {formik.getFieldMeta(getName(detail)).touched &&
                isAbnormalValue(formik.values[getName(detail)!], detail, 'ratio') && (
                    <div>
                        <i className="fa-solid fa-warning text-warning me-1" />
                        {outOfRangeText(detail, true, 'Systolic', 'ratio')}
                    </div>
                )}
            {formik.getFieldMeta(`${getName(detail)}2`).touched &&
                isAbnormalValue(formik.values[`${getName(detail)}2`], detail, 'ratio2') && (
                    <div>
                        <i className="fa-solid fa-warning text-warning me-1" />
                        {outOfRangeText(detail, true, 'Diastolic', 'ratio2')}
                    </div>
                )}
        </>
    );
}
